import {
  SWITCH_PLATFORM,
  SWITCH_PLATFORM_ERROR,
  SWITCH_PLATFORM_SUCCESS,
  UPDATE_CREDIT_USERTYPE,
  UPDATE_CREDIT_USERTYPE_ERROR,
  UPDATE_CREDIT_USERTYPE_SUCCESS
} from "./actionTypes";

export const switchPlatform = () => {
	return {
		type: SWITCH_PLATFORM,
	};
};

export const switchPlatformSuccess = (data) => {
	return {
		type: SWITCH_PLATFORM_SUCCESS,
		payload: data,
	};
};

export const switchPlatformError = (error) => {
	return {
		type: SWITCH_PLATFORM_ERROR,
		payload: error,
	};
};

export const updateCreditUsertype = () => {
	return {
		type: UPDATE_CREDIT_USERTYPE,
	};
};

export const updateCreditUsertypeSuccess = (data) => {
	return {
		type: UPDATE_CREDIT_USERTYPE_SUCCESS,
		payload: data,
	};
};

export const updateCreditUsertypeError = (error) => {
	return {
		type: UPDATE_CREDIT_USERTYPE_ERROR,
		payload: error,
	};
};